const actionTypes = require('../../actionTypes.js');
const stateBuilder = require("../../stateBuilder.js")

module.exports.createAction = function (currentComponent)
{
    return (
        {
            type: actionTypes.currentComponent,
            payload: currentComponent
        }
    );
}

module.exports.changeState = function (previousState, payload)
{
    if (payload == null)
        return stateBuilder.createState();
    else
        return Object.assign({}, previousState, { currentComponent: payload });
}